import { Validator } from "./Validator";

export class TypedValueValidator<TRawValue, TParsedValue> {
    public rawValidator: Validator<TRawValue>;

    public parsedValidator: Validator<TParsedValue>;
    private _parseValue: (rawValue: TRawValue) => TParsedValue;

    constructor(parseValue: (rawValue: TRawValue) => TParsedValue) {
        this._parseValue = parseValue;
        this.rawValidator = new Validator();
        this.parsedValidator = new Validator();
    }

    public getValidationErrors(rawValue: TRawValue): string[] {
        const rawErrors: string[] = this.rawValidator.getValidationErrors(rawValue);
        if (rawErrors && rawErrors.length && rawErrors.length > 0) {
            return rawErrors;
        }

        const parsedValue = this._parseValue(rawValue);
        const parsedErrors = this.parsedValidator.getValidationErrors(parsedValue);

        return parsedErrors;
    }

    public getUnresolvedValidationErrors(rawValue: TRawValue): string[] {
        const rawErrors: string[] = this.rawValidator.getUnresolvedValidationErrors(rawValue);
        if (rawErrors && rawErrors.length && rawErrors.length > 0) {
            return rawErrors;
        }

        const parsedValue = this._parseValue(rawValue);
        const parsedErrors = this.parsedValidator.getUnresolvedValidationErrors(parsedValue);

        return parsedErrors;
    }
}
